import React from 'react';
import { CheckIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownPanel } from './CountdownPanel';
import { checkoutNote, checkoutUrl, offer } from '../data/content';
interface PricingProps {
  showUrgency?: boolean;
}
export function Pricing({
  showUrgency = true
}: PricingProps) {
  return <section id="planes" className="w-full bg-white py-16 md:py-24" data-id="element-156" data-mp="1vu1rmktbnftf">
      <div className="mx-auto w-full max-w-content px-5 md:px-8" data-id="element-157" data-mp="1vubjkdxxfx1r">
        {showUrgency && <CountdownPanel data-id="element-158" data-mp="1ru14mbs5pwar" />}

        <h2 className="mt-16 text-center font-display text-[2rem] font-extrabold leading-tight tracking-tight text-ink md:text-5xl" data-id="element-159" data-mp="1rut0zotkvy23">
          Tu inversión en el <span className="text-blue-600" data-id="element-160" data-mp="20s3ap5qqzf4w">Atlas Kinesio-Visual</span>
        </h2>

        <div className="mx-auto mt-10 max-w-narrow rounded-2xl bg-white p-7 shadow-lift ring-2 ring-blue-600 md:p-10" data-id="element-161" data-mp="3h6v3hjrt2oeq">
          <p className="text-center font-display text-xl font-extrabold uppercase tracking-tight text-ink md:text-2xl" data-id="element-162" data-mp="3c7i8ucup0d1l">
            {offer.name}
          </p>
          <p className="mt-2 text-center text-lg text-blue-900/75" data-id="element-163" data-mp="4svulmgz8wra">{offer.summary}</p>

          <ul className="mx-auto mt-8 grid max-w-xl gap-4 text-left sm:grid-cols-2" data-id="element-164" data-mp="4uyrmqgjrq5i">
            {offer.includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-165" data-mp="erletlwcitap">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-mint-50 text-mint-600" data-id="element-166" data-mp="eoz4jei2lzos">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-167" data-mp="3i78z079gpu3c" />
                </span>
                <span className="text-ink" data-id="element-168" data-mp="3n6llus0c315x">{item}</span>
              </li>)}
          </ul>

          <div className="mt-10 text-center" data-id="element-169" data-mp="3rydfjbesdn0a">
            <p className="text-lg text-blue-900/45" data-id="element-170" data-mp="3rz6dpnzoj46t">
              Valor real <span className="line-through" data-id="element-171" data-mp="2uhenpu4skdl7">{offer.listPrice}</span>
            </p>
            <p className="font-display text-5xl font-extrabold tracking-tight text-ink md:text-6xl" data-id="element-172" data-mp="2zh0y7vt8jfqb">
              {offer.price}
              <span className="ml-2 text-xl font-semibold text-blue-900/55" data-id="element-173" data-mp="2rfjvpd4bymm3">USD</span>
            </p>
            <p className="mt-3 inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm font-bold text-mint-600" data-id="element-174" data-mp="2mh06n3ufwupi">
              <span className="rounded-lg bg-mint-50 px-3 py-1 uppercase tracking-wide" data-id="element-175" data-mp="318in12r7or9e">
                {offer.discount}
              </span>
              <span className="text-blue-900/70" data-id="element-176" data-mp="28h7d70rj40du">Ahorras {offer.savings}</span>
            </p>
          </div>

          <div className="mt-8" data-id="element-177" data-mp="23jz2tmcmh0n5">
            <CtaButton size="xl" className="w-full" href={checkoutUrl} data-id="element-178" data-mp="23l0ftwd77x7i">
              {offer.cta}
            </CtaButton>
            <p className="mt-3 text-center text-sm text-blue-900/60" data-id="element-179" data-mp="2dh3hl1451ttx">{checkoutNote}</p>
          </div>

          <p className="mt-4 text-center text-sm text-blue-900/60" data-id="element-180" data-mp="3tvbt80ndeiqs">
            Acceso inmediato | 100% digital | Garantía 7 días
          </p>
        </div>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-2 text-sm font-medium text-blue-900/70" data-id="element-181" data-mp="3ovqu9q87aae2">
          <li className="inline-flex items-center gap-2" data-id="element-182" data-mp="cqb3qv2na75">
            <LockIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-183" data-mp="5a9o6ng19gxi" /> Pago 100% seguro
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-184" data-mp="3ngo3apq1fwxh">
            <ZapIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-185" data-mp="3rg595k9dmw36" /> Descarga en 2 minutos
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-186" data-mp="j0llr1ve07w1">
            <ShieldCheckIcon className="h-4 w-4 text-mint-500" aria-hidden="true" data-id="element-187" data-mp="j37sizagejd7" /> Garantía 7 días
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-188" data-mp="a8tbar6d4yrg">
            <CreditCardIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-189" data-mp="a8b7n9hdfi9i" /> Mercado Pago |
            Transferencia
          </li>
        </ul>
      </div>
    </section>;
}